import { LinkButton } from "@components/Buttons"
import { Loader } from "@components/Icons"
import { useIntl } from "@components/Intl"
import { AnimatePresence, motion } from "framer-motion"
import { useRouter } from "next/router"
import React, { Fragment } from "react"
import * as S from "./elements"
import { useCombinedImageImages } from "./hooks/use-combined-image-images"
type Props = {}

const CombinedImage: React.FC<Props> = (props) => {
  const { query } = useRouter()
  const { urls, status, refetch } = useCombinedImageImages()
  const { messages } = useIntl()

  return (
    <>
      <S.Wrapper>
        <AnimatePresence>
          {status === "error" && (
            <motion.div
              key="error"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
            >
              <S.Reload>
                {messages.global.oops}
                <LinkButton onClick={() => refetch()}>
                  {messages.configurator.tryAgain}
                </LinkButton>
              </S.Reload>
            </motion.div>
          )}
          {(status === "success" || status === "loading") && (
            <motion.div
              key={urls.join("-")}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0 }}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "calc(100% - 4rem)",
              }}
            >
              {urls.map((url, index) => {
                const elevateBaseImage =
                  query.type === "earring" && query.style === "hippiechic"
                return (
                  <Fragment key={`image-${index}`}>
                    <S.Image
                      alt=""
                      src={url}
                      variant={
                        query.type === "earring" ? "earring-left" : false
                      }
                      // The base is the first image in the array
                      // for rings this is perfect, because it should be the lowest layer of the combined image
                      // for hippiechic earrings the base should be the highest layer
                      isElevated={elevateBaseImage && index === 0}
                    />
                    {query.type === "earring" && (
                      <S.Image
                        alt=""
                        src={url}
                        variant={"earring-right"}
                        isElevated={elevateBaseImage && index === 0}
                      />
                    )}
                  </Fragment>
                )
              })}
            </motion.div>
          )}
        </AnimatePresence>
        <S.LoaderBar height="4rem">
          {status === "loading" && <Loader />}
        </S.LoaderBar>
      </S.Wrapper>
    </>
  )
}

export default CombinedImage
